export function init() {
  // this only adds the A/B test experiment and variation IDs to the tracking
  // info of the teaser elements, so that the module tracking also sends this
  // information. The actual A/B test logic is handled in inline JS/CSS in
  // ab-testing.twig
  const currentGroup = document.body.dataset.abTestGroup;
  const testedElements = document.querySelectorAll(
    `.ab-test-location[data-ab-test-group="${currentGroup}"]`,
  );

  testedElements.forEach((el) => {
    const teaserElement = el.closest('.js-teaser');
    if (teaserElement) {
      const experimentId = el.dataset.abTestExperimentId;
      const variationId = el.dataset.abTestVariationId;
      if (experimentId && variationId) {
        const prev = teaserElement.dataset.referrerTrack || '';
        teaserElement.dataset.referrerTrack = `${prev}&ab_test_experiment_id=${experimentId}&ab_test_variation_id=${variationId}`;
      }
    }
  });
}
